/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import { MeetingInfo } from './MeetingService';

// endpoint local listener interface documented here: https://confluence.ops.expertcity.com/display/proddev/Local+Server%3A+Communication+Protocol
export interface EndpointParameters {
  iat: number;
  endpointParams: {
    Action: string;
    Product: string;
    sessionTrackingId: string;
    MeetingID?: string;
    EGWAddress: string;
    EGWDNS: string;
    EGWPort: string;
    Mode: string;
    authorizationCode?: string;
    redirectUri?: string;
  };
  version: string;
}

export interface EndpointTokenHeader {
  alg: string;
  typ: string;
}

// parameters documented here: https://confluence.ops.expertcity.com/display/~ivang/Command+Line+Parameters+Used+by+GoToMeeting+Desktop+EP
export const makeEndpointParametersFromMeetingInfo = (
  meetingInfo: MeetingInfo,
  meetingId: string | undefined,
  stId: string
): EndpointParameters => {
  const iatInSeconds = Math.round(new Date().getTime() / 1000);
  const endpointParameters: EndpointParameters = {
    iat: iatInSeconds,
    endpointParams: {
      Action: 'Join',
      Product: 'g2m',
      sessionTrackingId: stId,
      EGWAddress: '13.248.136.72',
      EGWDNS: 'egwi2global.gotomeeting.com',
      EGWPort: '80,443,8200',
      Mode: 'Terse',
    },
    version: '1.0',
  };
  if (meetingId) {
    endpointParameters.endpointParams.MeetingID = meetingId;
  }
  if (meetingInfo.authorizationCode) {
    endpointParameters.endpointParams.authorizationCode =
      meetingInfo.authorizationCode;
    endpointParameters.endpointParams.redirectUri =
      'urn:citrix:oauth:direct_code';
  }
  return endpointParameters;
};
